import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import WebViewHeader from '../../template/WebViewHeader/WebViewHeader';
import AXIOS from '../../api/axios';

import './style.less';
import CustomerService from './customerService';
import UA from '../../utils/ua';


class FeedbackDetailPage extends Component {
    constructor(props){
        super(props);
        this.isMobile = UA.mobileClient;
        this.state = {
            title: '', // 标题
            content: '', // 内容
            id: props.match.params.id || '' // 作业id 从路由中拿
        }
    }
    componentWillMount(){
        const { id } = this.state;
        // 根据id获取作业详情
        AXIOS.getFeedBackDetail({
            query: id
        }, (res,err) => {
            if(err) console.log(err);
            else{
                this.setState(res)
            }
        })
    }

    render(){
        const { content, title, id } = this.state;
        return(
            <DocumentTitle title={'问题详情'}>
                <React.Fragment>
                    { !this.isMobile &&
                        <WebViewHeader showBack={ true } showClose={ false } title="问题详情" />
                    }
                    <div className={`container feedback-detail ${this.isMobile ? 'mobile' : 'pc'}`}>
                        <div className="title" style={{"WebkitBoxOrient":"vertical"}}>{ title }</div>
                        <div className="content" dangerouslySetInnerHTML={{ __html: content }} />
                        {this.isMobile && <CustomerService oringin="feedback_detail" questionId={ id } isMobile={this.isMobile} />}
                    </div>
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default FeedbackDetailPage;



// WEBPACK FOOTER //
// ./src/components/feedbackPage/feedbackDetailPage.jsx